
export const RadioButton= ({ value, name, label, disabled, checked, onChange }) => {
    return <div
        style={{ ...(disabled && { opacity: 0.5 }) }}
    ><input type="radio" id={"rd-" + value} value={value}
        disabled={disabled}
        readOnly={disabled}
        name={name}
        checked={checked}
        onChange={onChange} />
        <label htmlFor={"rd-" + value}>
            {label}
        </label>
    </div>

}
